// Placeholder / stock imagery — all replaceable later in the CMS.
export const IMAGES = {
  hero: "https://images.pexels.com/photos/14658666/pexels-photo-14658666.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  domestic: "https://images.pexels.com/photos/38033523/pexels-photo-38033523.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  commercial: "https://images.unsplash.com/photo-1630311853242-edd0c07766c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  lineMarking: "https://images.pexels.com/photos/15562223/pexels-photo-15562223.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  sports: "https://images.unsplash.com/photo-1501520158826-76df880863a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  golf: "https://images.pexels.com/photos/27309420/pexels-photo-27309420.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  grass: "https://images.pexels.com/photos/12932883/pexels-photo-12932883.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
